export enum FormErrorsTypes {
    WHITESPACES_ERROR = 'Field cannot contain only whitespaces',
    REQUIRED_ERROR = 'This is required field',
    EMAIL_ERROR = 'This email is not correct'
}
